import { IModalsConfig } from '../../modals.config.interface';

export const EOP_MILESTONE_MODAL_CONFIG: IModalsConfig = {
  buttons: {
    confirm: { text: 'Confirm', disableButtonRipple: true },
    cancel: { text: 'Cancel', disableButtonRipple: true },
  },
};
